import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, setAdminToken } from "../lib/api";
import { Lock, Loader2 } from "lucide-react";
import { toast } from "sonner";
import FSSLogo from "../components/site/FSSLogo";

export default function AdminLogin() {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/admin/login", { password });
      setAdminToken(res.data.token);
      toast.success("Welcome back");
      navigate("/admin/leads");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col" data-testid="admin-login-page">
      <div className="bg-white border-b border-slate-200">
        <div className="fss-container h-20 flex items-center">
          <FSSLogo />
        </div>
      </div>

      <div className="flex-1 grid place-items-center px-4 py-16">
        <div className="w-full max-w-md fss-card">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-12 h-12 bg-green-50 border border-green-100 flex items-center justify-center rounded-sm">
              <Lock className="w-6 h-6 text-green-700" />
            </div>
            <div>
              <div className="fss-overline">Admin Access</div>
              <h1 className="font-display text-2xl font-semibold text-slate-900 leading-tight">
                Sign in to FSS Leads
              </h1>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <label className="block">
              <span className="block text-xs font-bold tracking-[0.18em] uppercase text-slate-700 mb-2">
                Password
              </span>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="fss-input"
                placeholder="••••••••••••"
                required
                autoFocus
                data-testid="admin-login-password"
              />
            </label>

            <button
              type="submit"
              disabled={loading}
              className="fss-btn fss-btn-primary w-full justify-center disabled:opacity-60"
              data-testid="admin-login-submit"
            >
              {loading ? (
                <>
                  <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                  Signing in...
                </>
              ) : (
                "Sign in"
              )}
            </button>
          </form>

          <p className="mt-6 text-xs text-slate-500 text-center">
            FSS internal access only. Unauthorised access is prohibited.
          </p>
        </div>
      </div>
    </div>
  );
}
